<script>
  import CloseButton from '@/_legacy/components/Modals/CloseButton.vue';

  export default {
    name: 'ConductInspectionModalCancel',
    components: { CloseButton },
    methods: {
      handleClose() {
        this.$emit('close');
      },
    },
  };
</script>

<template>
  <modal @modal-close="handleClose">
    <div class="modal-wrapper">
      <CloseButton @click="handleClose" />

      <div class="modal-content">
        <p>
          {{
            $t(
              'Are you sure to quit this inspection? All your changes will be lost.',
            )
          }}
        </p>
      </div>

      <div class="modal-actions-outer-wrapper">
        <div class="modal-actions-inner-wrapper">
          <button
            type="button"
            class="modal-actions-secondary"
            @click.prevent="handleClose"
          >
            {{ $t('No, I want to continue') }}
          </button>

          <button
            type="button"
            class="modal-actions-primary"
            @click.prevent="$emit('confirm')"
          >
            {{ $t('Yes, quit now') }}
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>
